// Claude: version display utilities — format commit hashes, cache server hash in localStorage 28-03-2026
const LS_KEY = 'aftr_server_hash';

export const formatVersion = (feHash: string, beHash: string): string => {
  const fmt = (h: string) => h && h.length >= 4 ? `${h.slice(0, 2)}*${h.slice(-2)}` : (h || '??');
  return `Ver:F:${fmt(feHash)}-S:${fmt(beHash)}`;
};

export const getCachedServerHash = (): string =>
  localStorage.getItem(LS_KEY) || '??';

export const fetchAndCacheServerHash = async (): Promise<void> => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/version`);
    const data = await res.json();
    const hash = data?.commitHash || data?.data?.commitHash;
    if (hash) localStorage.setItem(LS_KEY, hash);
  } catch (_) {
    // silently fail — cached value remains
  }
};
